// extracted by mini-css-extract-plugin
export default {"content-title":"ContentTitle_content-title__Zk0BG"};